import { useQuery } from '@tanstack/react-query';

import { kinds, type EnvKey } from '@/app/site/scope';
import { contentBlockTypes } from '@/shared/api/generated/content/content';

/** Компоненты окружения с полями: свои и встроенные. */
export function useBlockTypes(siteId: string, env: EnvKey) {
  return useQuery({
    queryKey: ['block-types', siteId, env],
    queryFn: async () => {
      const response = await contentBlockTypes(siteId, kinds[env]);

      if (response.status !== 200) {
        throw new Error('Неожиданный ответ на запрос компонентов');
      }

      return response.data.items ?? [];
    },
  });
}

/** Адрес встроенного компонента: у него нет своего типа в схеме. */
export const BUILTIN_PREFIX = 'builtin-';
